import React, { useState } from 'react';

import { AccessControl } from '@C/Utils';

import { CashierImport } from './CashierImport';
import { CreditCustomerImport } from './CreditCustomerImport';
import { CreditSlipImport } from './CreditSlipImport';
import './styles.scoped.scss';

const DATA_TYPES = [
  { value: 'credit_customers', label: 'Credit Customers' },
  { value: 'credit_slips', label: 'Credit Slips' },
  { value: 'staff', label: 'Staff' },
];

const DataMigration = () => {
  const [dataType, setDataType] = useState('credit_customers');

  return (
    <AccessControl allowedRoles={['Dealer']}>
      <section className="widget full-width">
        <header className="form-header">
          <h3>Data Migration</h3>
        </header>
        <main>
          <div className="data-type-tabs">
            {DATA_TYPES.map((type) => (
              <button
                key={type.value}
                className={`data-type-tab ${
                  dataType === type.value ? 'active' : ''
                }`}
                onClick={() => setDataType(type.value)}
              >
                {type.label}
              </button>
            ))}
          </div>
        </main>
      </section>

      {dataType === 'credit_customers' && <CreditCustomerImport />}
      {dataType === 'credit_slips' && <CreditSlipImport />}
      {dataType === 'staff' && <CashierImport />}
    </AccessControl>
  );
};

export { DataMigration };
